import * as React from "react"
import { Box, Chip } from "@mui/material"

import { NotAllowedBlock } from "@components"


export default function stockStatusColumn(name, label, color) {
	return {
		name: name, label: label,
		options: {
			customBodyRowRender: (value, row) => {
				return <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
					{!!value && <Chip label={value} sx={{ backgroundColor: row[color] }} />}
					{!value && <NotAllowedBlock />}
				</Box>
			}
		}
	}
}